import type { SiteConfig, BeforeAfterItem } from '../../../siteContentTypes.ts';
import { TextField, SelectField, ListEditor } from './fields.tsx';
import { ICON_NAMES } from '../../../lib/icons.ts';

function ItemsEditor({ items, onChange }: { items: BeforeAfterItem[]; onChange: (items: BeforeAfterItem[]) => void }) {
  return (
    <ListEditor<BeforeAfterItem>
      items={items}
      onChange={onChange}
      itemLabel="un élément"
      newItem={() => ({ text: 'Nouvel élément', icon: 'check' })}
      renderItem={(item, patch) => (
        <>
          <TextField label="Texte" value={item.text} onChange={(v) => patch({ text: v })} />
          <SelectField label="Icône" value={item.icon} onChange={(v) => patch({ icon: v })} options={ICON_NAMES.map((n) => ({ value: n, label: n }))} />
        </>
      )}
    />
  );
}

export function BeforeAfterSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const b = config.beforeAfter;
  const set = (patch: Partial<SiteConfig['beforeAfter']>) => update({ beforeAfter: { ...b, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Avant / après</h2>
      <TextField label="Titre de la section" value={b.title} onChange={(v) => set({ title: v })} />

      <h3 style={{ fontSize: 14, fontWeight: 800, margin: '24px 0 10px' }}>Avant</h3>
      <TextField label="Titre" value={b.before.title} onChange={(v) => set({ before: { ...b.before, title: v } })} />
      <ItemsEditor items={b.before.items} onChange={(items) => set({ before: { ...b.before, items } })} />

      <h3 style={{ fontSize: 14, fontWeight: 800, margin: '24px 0 10px' }}>Après</h3>
      <TextField label="Titre" value={b.after.title} onChange={(v) => set({ after: { ...b.after, title: v } })} />
      <ItemsEditor items={b.after.items} onChange={(items) => set({ after: { ...b.after, items } })} />
    </div>
  );
}
